module.exports = __webpack_public_path__ + "img/470-40786a.png";